import { render } from "./editAiSentence.vue?vue&type=template&id=479ef2dc&scoped=true"
import script from "./editAiSentence.vue?vue&type=script&lang=js"
export * from "./editAiSentence.vue?vue&type=script&lang=js"

import "./editAiSentence.vue?vue&type=style&index=0&id=479ef2dc&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479ef2dc"],['__file',"src/views/aiProduct/components/editAiSentence.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "479ef2dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('479ef2dc', __exports__)) {
    console.log('reload')
    api.reload('479ef2dc', __exports__)
  }
  
  module.hot.accept("./editAiSentence.vue?vue&type=template&id=479ef2dc&scoped=true", () => {
    console.log('re-render')
    api.rerender('479ef2dc', render)
  })

}


export default __exports__